exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.notice[data-v-7add6556] {\n  padding-top: 20px;\n  color: red !important;\n  text-transform: none;\n}\n.text-danger[data-v-7add6556] {\n  color: red;\n}\n@media only screen and (max-width: 768px) {\n.notice[data-v-7add6556] {\n    padding-bottom: 20px;\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7add6556","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/waitlist/NewWaitlistModal.vue
// module id = Ke/h
// module chunks = 1